export const getDateSlots = () => {
  const slots: { month: string; day: string; fullDate: string }[] = [];
  let offset = 0; // Start from 0 to include Today

  while (slots.length < 3) {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    offset += 1;

    if (date.getDay() === 0) continue;

    const year = date.getFullYear();
    const monthNumber = String(date.getMonth() + 1).padStart(2, "0");
    const dayNumber = String(date.getDate()).padStart(2, "0");

    slots.push({
      month: date.toLocaleString("en-US", { month: "short" }),
      day: dayNumber,
      fullDate: `${year}-${monthNumber}-${dayNumber}`,
    });
  }

  return slots;
};
